import { useDispatch, useSelector } from "react-redux"
import { numberWithCommas } from "../../helpers/numbers"
import { useEffect, useState } from "react"
import { textWithFirstCharUpper, textWithOnlyUpper } from "../../helpers/string"

export const ReviewDetailsForm = ({selectedTab,  setCurrentTab , isLoading}) => {

    const dispatch = useDispatch()
    const togglePasswordVisibility = () => {
        setShowPassword((prevState) => !prevState);
      };

  const userstate = useSelector(state => state.user)
  const [showPassword, setShowPassword] = useState(false); 

 useEffect(()=>
{
    console.log("hit")
    setShowPassword(false)
},[selectedTab])

    return (
        <div>
            <div className="card card-grey review mb-3">
                <div className="card-body">
                    <p className="mb-1 font-16 font-weight-700 text-light-default">
                       User Details
                    </p>
                    <table className="table">
                        <tbody>
                            <tr>
                                <td>
                                    <div className="font-12 opacity-70">Emirates Id.</div>
                                </td>
                                <td>
                                    <div className="font-12 font-weight-600">{userstate.emiratesID != "" ? (userstate.emiratesID) : "N/A"}</div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div className="font-12 opacity-70">Email address</div>
                                </td>
                                <td>
                                    <div className="font-12 font-weight-600 eWidth">
                                        {userstate.emailAddress != "" ? userstate.emailAddress : "N/A"}
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div className="font-12 opacity-70">Full name</div>
                                </td>
                                <td>
                                    <div className="font-12 font-weight-600 eWidth">
                                        {userstate.fullName != "" ? userstate.fullName : "N/A"}
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div className="font-12 opacity-70">Organization name</div>
                                </td>
                                <td>
                                    <div className="font-12 font-weight-600 eWidth">
                                        {userstate.organizationName != "" ? userstate.organizationName : "N/A"}
                                    </div>
                                </td>
                            </tr>
                           {userstate.phoneNumber.length>0 && <tr>
                                <td>
                                    <div className="font-12 opacity-70">Phone number</div>
                                </td>
                                <td>
                                    <div className="font-12 font-weight-600">+{userstate.phoneNumber != "" ? userstate.phoneNumber : "N/A"}</div>
                                </td>
                            </tr>}

                            <tr>
                                <td>
                                    <div className="font-12 opacity-70">New password</div>
                                </td>
                                <td>
                                    <div className="font-12 font-weight-600 eWidth">
                                    {showPassword ?(userstate.password != "" ? userstate.password : "N/A") : "***********"}
                                    <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            togglePasswordVisibility();
          }}
          style={{
            display: "block",
            marginBottom: "20px",
            color: "blue",
            cursor: "pointer",
          }}
        >
           
          {showPassword ? "Hide password" : "Review password"}
        </a>
        {!isLoading &&  <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            setCurrentTab(2)
          
          }}
          style={{
            display: "block",
            marginBottom: "20px",
            color: "blue",
            cursor: "pointer",
          }}
        >
           
          Change password
        </a>}
       
                                    </div>
                                </td>
                            </tr>
                            
                          
                        </tbody>
                    </table>
                   
                 
                </div>
            </div>
          
            <p className="font-20">Undertaking</p>
            <div className="row">
              
            </div>
            {/* <UndertakingConsentModal id={undertakingModalState.id} show={undertakingModalState.isOpen} close={closeModal} content={undertakingModalState.content} /> */}
        </div>
    )
}